import { ModalType } from './ModalRoot.types';

export function getModalSelectedByList<T extends string>(
  typeModal: T | null,
  types: ModalType<T>[]
) {
  return types.find(type => type.key === typeModal);
}

